import {
  getAllSupervisorsSuccess,
  getAllSupervisorsFail,
  addNewUserSuccess,
  addNewUserFail, 
  editExistingUserSuccess, 
  editExistingUserFail, 
  deleteExistingUserSuccess, 
  deleteExistingUserFail
} from "../constants/supervisor"
import { addNewSupervisorApi, deleteSupervisorApi, getAllSuperviorsApi, editSupervisorApi } from "../../apis/supervisor";
import { showNotification } from "./notification";

export function getAllSuperviorsSuccess(res) {
  return ({ type: getAllSupervisorsSuccess, payload: res })
}

export function getAllSuperviorsFail() {
  return ({ type: getAllSupervisorsFail })
}

export function addNewSupervisorSuccess(payload) {
  return ({type: addNewUserSuccess, payload: payload})
}

export function addNewSupervisorFail() {
  return ({type: addNewUserFail})
}

export function editExistingSupervisorSuccess(payload) {
  return ({type: editExistingUserSuccess, payload: payload})
}

export function editExistingSupervisorFail() {
  return ({type: editExistingUserFail})
}

export function deleteExistingSuperVisorSuccess(payload) {
  return ({ type: deleteExistingUserSuccess, payload: payload })
}

export function deleteExistingSuperVisorFail() {
  return ({ type: deleteExistingUserFail })
}

export function getAllSuperviors() {
  return ((dispatch) => {
    getAllSuperviorsApi().then(
      (res = {}) => {
        dispatch(getAllSuperviorsSuccess(res));
      })
      .catch((error = {}) => {
        dispatch(getAllSuperviorsFail());
      })
  })
}

export function addNewSupervisor(payload) {
  return ((dispatch) => {
    addNewSupervisorApi(payload).then(
      (res = {}) => {
        dispatch(addNewSupervisorSuccess(payload));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'New User Added Successfully',
        }));
      })
      .catch((error = {}) => {
        dispatch(addNewSupervisorFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: 'Unable to add New User',
        }));
      })
  })
}

export function editSupervisor(payload, id) {
  return ((dispatch) => {
    editSupervisorApi(payload, id).then(
      (res = {}) => {
        dispatch(editExistingSupervisorSuccess(payload));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'User Data Modified Successfully',
        }));
      })
      .catch((error = {}) => {
        dispatch(editExistingSupervisorFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failue',
          description: error?.message
        }));
      })
  })
}

export function delelteSupervisor(id) {
  return ((dispatch) => {
    deleteSupervisorApi(id).then(
      (res = {}) => {
        dispatch(deleteExistingSuperVisorSuccess(res.body));
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'User Data Deleted Successfully',
        }));
      })
      .catch((error = {}) => {
        dispatch(deleteExistingSuperVisorFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: error?.message
        }));
      })
  })
}